import ErrorEntities from '@/models/error-entities'

import { CustomerMutationTypes } from '@/store/modules/customer'

export interface State {
  visible: boolean
  errors: ErrorEntities
}

export enum ChangePasswordModalMutationTypes {
  Open = '[ChangePasswordModal] Open',
  Close = '[ChangePasswordModal] Close',
}

const initialState: State = {
  visible: false,
  errors: {},
}

export default {
  state: initialState,
  getters: {
    getChangePasswordModalVisible(state: State) {
      return state.visible
    },
    getChangePasswordModalErrors(state: State) {
      return state.errors
    },
  },
  mutations: {
    [ChangePasswordModalMutationTypes.Open](state: State) {
      state.visible = true
      state.errors = {}
    },
    [ChangePasswordModalMutationTypes.Close](state: State) {
      state.visible = false
    },
    [CustomerMutationTypes.ChangePasswordSuccess](state: State) {
      state.visible = false
      state.errors = {}
    },
    [CustomerMutationTypes.ChangePasswordFailure](
      state: State,
      errors: ErrorEntities,
    ) {
      state.errors = errors
    },
  },
}
